export default __webpack_public_path__ + "static/media/home-emergency-mapping-min.cf6ef62e.svg";